import React from 'react'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
} from '@chakra-ui/react'
import { Button } from '@apex/component-library'

interface AssetsAlertProps {
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
}

const AssetsAlert = ({ isOpen, onCancel, onConfirm }: AssetsAlertProps) => (
  <AlertDialog
    isCentered
    isOpen={isOpen}
    leastDestructiveRef={undefined}
    motionPreset="slideInBottom"
    onClose={onCancel}
  >
    <AlertDialogOverlay>
      <AlertDialogContent>
        <AlertDialogHeader>No Assets Added</AlertDialogHeader>
        <AlertDialogBody data-testid="assets-alert-body">
          <p>
            A partial transfer requires adding at least one specific asset, but
            none have been entered.
          </p>
          <br />
          <p>
            You can go back and add assets, or perform a Full Transfer instead.
          </p>
        </AlertDialogBody>
        <AlertDialogFooter>
          <Button
            variant="white"
            onClick={onCancel}
            data-testid="assets-alert-add-assets-button"
          >
            Add Assets
          </Button>
          <Button
            variant="primary"
            onClick={onConfirm}
            ml={3}
            data-testid="assets-alert-full-transfer-button"
          >
            Perform Full Transfer
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialogOverlay>
  </AlertDialog>
)

export default AssetsAlert
